import { useEffect, useState } from 'react';
import { APP_VERSION } from '../version';

const POLL_INTERVAL_MS = 5 * 60 * 1000;

// Detects when a new frontend build has been deployed by comparing the version
// baked into this running bundle (APP_VERSION, stamped at build time by
// scripts/generate-version.js from the current git commit) against
// /version.json, a small static file regenerated on every build/start and
// always fetched fresh (no-store + cache-busting query param) so it reflects
// whatever the server is currently serving, not whatever this tab loaded.
export function useVersionCheck() {
    const [updateAvailable, setUpdateAvailable] = useState(false);

    useEffect(() => {
        const check = async () => {
            try {
                const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
                if (!res.ok) return;
                const data = await res.json();
                if (data?.version && data.version !== APP_VERSION) {
                    setUpdateAvailable(true);
                }
            } catch {
                // Network hiccup - just try again next interval, not worth surfacing.
            }
        };

        const interval = setInterval(check, POLL_INTERVAL_MS);
        const onVisible = () => { if (document.visibilityState === 'visible') check(); };
        document.addEventListener('visibilitychange', onVisible);
        window.addEventListener('focus', check);

        return () => {
            clearInterval(interval);
            document.removeEventListener('visibilitychange', onVisible);
            window.removeEventListener('focus', check);
        };
    }, []);

    return { updateAvailable };
}
